import { Component } from '@angular/core'

@Component({
  selector: 'aku-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'foto-admin-app'
}
